import { mdiVideo } from '@lumapps/lumx/icons';

export const WIDGET_VIDEO_TYPE = 'video';
export const WIDGET_VIDEO_ICON = mdiVideo;
export const WIDGET_VIDEO_EDITION_SCOPE = 'widget-video-edition';

/**
 * Contains some common URL pattern for the video that needs a placeholder.
 */
export const URL_PATTERNS = {
    microsoft: ['sharepoint.com', 'microsoftstream.com'],
};
